// https://github.com/bvaughn/react-window/issues/6
// https://gist.github.com/tsirlucas/637c948e1e55a3c2439df9b87ec6a13b

import { useState, useEffect, useCallback } from 'react';

const useReverseScroll = ({ ref, data }) => {
  const [indexesCoordinates, setIndexesCoordinates] = useState({});
  const [lastData, setLastData] = useState([]);
  const [totalScrollSize, setTotalScrollSize] = useState(0);
  const [divHeight, setDivHeight] = useState(0);
  const [isScrolledToBottom, SetIsScrolledToBottom] = useState(false);

  const updateScrollValues = useCallback((currentRef) => {
    // Keep track of div size and scroll size so we can decide how much we
    // want to scroll and if we want to
    setTotalScrollSize((currentScrollSize) => {
      if (currentRef && currentRef._instanceProps) {
        // No totalMeasuredSize in VariableSizeList so We need to calculate it manually
        const totalMeasuredSize =
          Object.keys(currentRef._instanceProps.itemMetadataMap).length > 0
            ? currentRef._instanceProps.itemMetadataMap[
                Object.keys(currentRef._instanceProps.itemMetadataMap).length -
                  1
              ].offset
            : 0;
        if (currentRef && totalMeasuredSize !== totalScrollSize) {
          return totalMeasuredSize;
        }
      }
      return currentScrollSize;
    });
    setDivHeight((currentHeight) => {
      if (currentRef && currentRef.props.height !== currentHeight) {
        return currentRef.props.height;
      }
      return currentHeight;
    });
  }, []);

  useEffect(() => {
    // Should only scroll on data change if was scrolled to bottom
    // before the size change. So we use the last data <= 1
    // because we are subtracting the size for the last index
    const wasScrolledToBottom =
      lastData.length !== 0 &&
      lastData.length - indexesCoordinates.visibleStopIndex <= 1;
    const hasScroll = totalScrollSize > divHeight;
    const didItemsChange = lastData.length !== data.length;
    if (!isScrolledToBottom && lastData.length === data.length) {
      if (ref) {
        ref.scrollTo(ref._outerRef.children[0].clientHeight);
      }
      if (
        wasScrolledToBottom &&
        ref._outerRef.children[0].clientHeight === ref.state.scrollOffset
      ) {
        SetIsScrolledToBottom(true);
      }
    }
    setLastData(data);
    if (didItemsChange && hasScroll) {
      const firstItemLastData = lastData[0] || 0;
      const firstItemData = data[0] || 0;
      // // If it was scrolled to botom, we should keep the scroll there by scrolling
      // // to the bottom when new messages arrive
      if (wasScrolledToBottom) {
        // This ensures the scroll will be at the bottom when you open a scroll which you already have all data loaded
        ref.scrollTo(ref._outerRef.children[0].offsetHeight);
      } else if (!wasScrolledToBottom && firstItemLastData !== firstItemData) {
        // If user loaded new items by scrolling up, open the last position
        if (lastData.length !== 0) {
          ref.scrollToItem(data.length - lastData.length, 'start');
        }
      }
    }
  }, [
    data.length,
    lastData.length,
    isScrolledToBottom,
    indexesCoordinates,
    totalScrollSize,
    divHeight,
    ref,
  ]);

  useEffect(() => {
    updateScrollValues(ref);
  }, [
    ref && ref.props.height,
    ref && ref._instanceProps.totalMeasuredSize,
    ref && ref._instanceProps.itemOffsetMap,
  ]);

  const onItemsRendered = useCallback(
    (params) => {
      setIndexesCoordinates(params);
      if (ref) {
        // re render list so the size updated
        updateScrollValues(ref);
      }
    },
    [ref]
  );

  return { onItemsRendered };
};

export default useReverseScroll;
